import { message, Button, Col, ConfigProvider, Form, Tag, Row, Tooltip, Space, Table, Modal, Popconfirm, InputNumber, Select } from "./../../ui/ot";
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { ProTableOt as ProTableOT } from "./../../ui/ot";
import CanForm from "./CanForm";
import { useCan } from "../controller/CanController";
import { useTemplateType } from "../../template/controller/TemplateTypeController";

const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const Can = () => {
    const columns = [
        {
            title: '樣板名稱',
            dataIndex: 'name',
            key: 'name',
            width: '20rem',

        },
        {
            title: '分類名稱',
            dataIndex: 'template_type_name',
            key: 'template_type_name',
            width: '20rem',
            sorter: false,
            disabled: true,
        },
        {
            title: '回覆內容',
            dataIndex: 'message',
            key: 'message',
            width: 200,
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                let message = Object.keys(text)
                    .filter((key_name) => {
                        return Number.isInteger(parseInt(key_name))
                    })
                    .map((key) => {
                        return <>{text[key]?.content}</>
                    })

                return <>{message}</>
            }
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const selectedType = useRef([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.can_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.can_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.can_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.can_id)
                selectRow = selectRow.filter(row => row.can_id !== record.can_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }


    const {
        getCanData,
        postCanData,
        patchCanData,
        deleteCanData
    } = useCan({
        onFinish,
        onBefore,
    })

    const {
        templateTypeOption,
        getTemplateTypeOption
    } = useTemplateType({
        onFinish,
        onBefore,
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
        getTemplateTypeOption()
    }, [])

    return <Row>
        <Col span={24}>
            <ProTableOT
                actionRef={actionRef}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'can_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => [<>
                    模板分類：
                    <Select
                        type='primary'
                        style={{
                            color: "#000",
                            backgroundColor: "#ffedee",
                            width: "10rem"
                        }}
                        defaultValue={null}
                        options={[{ value: null, label: "全部" }, ...templateTypeOption]}
                        onSelect={(val) => {
                            selectedType.current = val;
                            return actionRef.current.reload()
                        }}
                    />
                </>,
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key,
                        template_type_id: selectedType.current
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20)
                    return getCanData(newParams)
                }}
                propsUseData={() => {
                    return {
                        postData: (value) => {
                            let datas = []
                            value.forEach(values => {
                                let elseParams = {
                                    template_type_id: values?.template_type_id,
                                    name: values?.name,
                                }
                                elseParams = setParamsFilter(elseParams)
                                let data = {
                                    name: values?.name,
                                    frequently: 0,
                                    message: {
                                        ...values?.message,
                                        ...elseParams
                                    }
                                }
                                datas.push(data)
                            })
                            return postCanData(datas)
                        },
                        patchData: (value) => {
                            let datas = []
                            value.forEach(values => {
                                let elseParams = {
                                    template_type_id: values?.template_type_id,
                                    name: values?.name,
                                }
                                elseParams = setParamsFilter(elseParams)
                                let data = {
                                    can_id: values?.can_id,
                                    name: values?.name,
                                    frequently: 0,
                                    message: {
                                        ...values?.message,
                                        ...elseParams
                                    }
                                }
                                datas.push(data)
                            });
                            return patchCanData(datas)
                        },
                        deleteData: deleteCanData
                    }
                }}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                PropsPatchForm={<CanForm />}
                propsPatchProcess={(data) => {
                    return {
                        ...data,
                        message: Object.entries(data?.message ?? {})
                            .filter(([key]) => !isNaN(key))  // 篩選 key 為數字的項目
                            .map(([_, value]) => value)
                    }
                }}
                propsPatch
                propsPost
                propsDelete
                formMode={true}
                pageSize={pageSize}
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys: selectedRowKeys,
                    ...rowSelection,
                }}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    )
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    x: "max-content"
                }}

            />
        </Col>
    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default Can


